import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { Producto } from '../../../_models/producto';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import {ZonaService} from '../../../_services/zona.service';
import {AgrupacionService} from '../../../_services/agrupacion.service';
import {EstructuraFisicaService} from '../../../_services/estructura-fisica.service';
import {DivisionPoliticaService} from '../../../_services/division-politica.service';
import {DivisionPolitica} from '../../../_models/division-politica';
import {ProductoRestriccionBarrio} from '../../../_models/producto-restriccion-barrio';
import {ProductoRestriccionBarrioService} from '../../../_services/producto-restriccion-barrio.service';
import {Listbox} from "primeng/listbox";
import { Table } from 'primeng/table';

@Component( {
  selector: 'app-producto-restriccion-barrios',
  templateUrl: 'producto-restriccion-barrios.component.html'
} )

export class ProductoRestriccionBarriosComponent implements OnInit {

  @Input() producto: Producto;
  // Lista de barrios
  listaBarrios: DivisionPolitica[] = [];
  // Producto restriccion barrio
  listaTodosProductosRestriccionBarrio: ProductoRestriccionBarrio[] = [];
  // Barrios que se modifican
  ListaBarriosMod: ProductoRestriccionBarrio[] = [] ;
  // Arreglo que almacena la lista de restricciones iniciales para compararla a la hora de enviar
  listaTodosProductosRestriccionBarrioOriginal: ProductoRestriccionBarrio[] = [];
  listaProductoRestriccionBarrio: ProductoRestriccionBarrio[] = [];
  productoRestriccionBarrio: ProductoRestriccionBarrio[] = [];
  listaProductosRestriccionBarrioRestringidos: ProductoRestriccionBarrio[] = [];
  productoRestriccionBarrioRestringido: ProductoRestriccionBarrio[] = [];
  listaFiltrada: ProductoRestriccionBarrio[] = [];
  // Ids para selectBox
  idPaisSeleccionado: string;
  idDepartamentoSeleccionado: string;
  idMunicipioSeleccionado: string;
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  tab = 'OFI';
  // Tabla
  columnas: any[] = [];

  // listas para combobox
  lisOficinas: SelectItem[] = [];
  lisPaises: SelectItem[] = [];
  lisDepartamentos: SelectItem[] = [];
  lisMunicipios: SelectItem[] = [];
  @ViewChild('myListbox') myListboxComponent: Listbox;
  @ViewChild('dt') table: Table;
  @ViewChild('dt2') table2: Table;
  esperar = false;

  filtroActivo: Boolean = true;
  carTabla: Boolean = false;

  ejecutandoRestriccion: Boolean = false;

  constructor(
               private navServicio: NavService,
               private location: Location,
               private estrucurasFisicaServicio: EstructuraFisicaService,
               private fb: FormBuilder,
               private zonaServicio: ZonaService,
               private agrupacionServicio: AgrupacionService,
               private productoRestriccionBarrioServicio: ProductoRestriccionBarrioService,
               private conServicio: ConfirmationService,
               private divisionPoliticaServicio: DivisionPoliticaService) {
  }

  ngOnInit(): void {
    this.cargarInformacionIncial();
  }

  cargarInformacionIncial() {
    // Cargando información inicial
    forkJoin(
        this.divisionPoliticaServicio.obtenerConHijos('0')
      )
      .subscribe( (
        [
          lisPais
        ] ) => {
        // llenado lista paises
        lisPais.map( ( s: DivisionPolitica ) => {
          this.lisPaises.push( { label: s.descripcionDivisonPolitica, value: s.idDivisionPolitica } );
        } );
        // Obtener el item del pais "Colombia" y precargarlo
        const divisionPaisColombia = lisPais.filter(objeto => objeto.codigoDivisionPolitica === 'PCOL');
        if (divisionPaisColombia) {
          this.idPaisSeleccionado = divisionPaisColombia[0].idDivisionPolitica;
          this.cambiarPais(this.idPaisSeleccionado);
        }

        this.listaTodosProductosRestriccionBarrio = [];
        this.listaFiltrada = [];

        this.columnas = [
          { field: 'nombreBarrio', header: this.navServicio.buscarMensaje( 'LBL_NOMBRE' ), sort: true }
        ];

        this.carInformacionInicial = false;
        this.filtrarProductosRestriccionBarrio();

      } );

  }

  get f() {
    return this.formulario.controls;
  }

  regresar() {
    this.location.back();
  }

  async filtrar() {
    if (this.listaTodosProductosRestriccionBarrio.length > 100){
      if (this.myListboxComponent.filterValue.length > 2) {
        if (this.esperar) {
          return;
        }
        this.productoRestriccionBarrioServicio.buscarAutoComplete(this.myListboxComponent.filterValue, this.producto.idProducto).subscribe(res => {
          this.listaFiltrada = res.filter( x => x.indicadorHabilitado ).slice(0, 99);
        });
        this.esperar = true;
        await new Promise(resolve => setTimeout(resolve, 100));
        this.esperar = false;
      } else {
        this.listaFiltrada = this.listaTodosProductosRestriccionBarrio.filter( x => x.indicadorHabilitado ).slice(0, 99);
      }
    }
  }

  async onSubmit() {
    // Mensaje para cuando no se ha realizado ningún cambio en el bulk
    if (this.ListaBarriosMod && this.ListaBarriosMod.length == 0  ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_BARRIONORELACIONADO' )
      } );
    } else {
      this.submitted = true;
      this.guardando = true;
      await this.enviarxPaquetes (this.ListaBarriosMod);
    }
  }

  async enviarxPaquetes(lista: any[]): Promise<void> {
    const tamanoPaquete = 500;
    const totalPaquetes = Math.ceil(lista.length / tamanoPaquete);
    try {
      for (let i = 0; i < totalPaquetes; i++) {
        const inicio = i * tamanoPaquete;
        const fin = inicio + tamanoPaquete;
        const paquete = lista.slice(inicio, fin);
        await  this.productoRestriccionBarrioServicio.bulk(paquete).toPromise();
      }
    }catch (error){
      return
    }

    await this.navServicio.setMesage( 1 );
    await this.filtrarDepartamentoMunicipio()
    this.carInformacionInicial = false;
    this.ListaBarriosMod = [];
    this.submitted = false;
    this.guardando = false;
  }

  regresarFormulario( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'producto-restriccion-barrios',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    }
  }
  cambiarPais( idPais: string ) {
    this.listaBarrios = [];
    this.lisDepartamentos = [];
    this.lisMunicipios = [];
    this.idPaisSeleccionado = idPais;
    this.idMunicipioSeleccionado = undefined;
    this.idDepartamentoSeleccionado = undefined;
    this.divisionPoliticaServicio.obtenerConHijos(this.idPaisSeleccionado ).subscribe(
      departamentos => {
        // llenado lista departamentos
        departamentos.map( ( s: DivisionPolitica ) => {
          this.lisDepartamentos.push( { label: s.descripcionDivisonPolitica, value: s.idDivisionPolitica } );
        } );
      }
    );
  }
  cambiarDepartamento( idDepartamento: string ) {
    this.listaBarrios = [];
    this.lisMunicipios = [];
    this.idDepartamentoSeleccionado = idDepartamento;
    this.idMunicipioSeleccionado = undefined;
    this.divisionPoliticaServicio.obtenerConHijos(this.idDepartamentoSeleccionado ).subscribe(
      municipios => {
        // llenado lista municipios
        municipios.map( ( s: DivisionPolitica ) => {
          this.lisMunicipios.push( { label: s.descripcionDivisonPolitica, value: s.idDivisionPolitica } );
        } );
      }
    );
  }
  cambiarMunicipio( idMunicipio: string ) {
    this.idMunicipioSeleccionado = idMunicipio;
  }

  filtrarDepartamentoMunicipio( ) {
    this.carTabla = true;
    this.productoRestriccionBarrio = []
    this.productoRestriccionBarrioRestringido = []
    this.ListaBarriosMod = []
    this.table.first = 0;
    this.table2.first = 0;
    this.filtroActivo = false;

    if (!this.idPaisSeleccionado || !this.idDepartamentoSeleccionado) {
      this.carTabla = false;
      this.filtroActivo = true;
      this.navServicio.setMesage(0, {
        severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('PRODUCTO.MSG_SINFILTRO')
      });
      return
    }

    if (this.idDepartamentoSeleccionado && this.idMunicipioSeleccionado) {
      this.listaBarrios = [];
      forkJoin
      (
        this.divisionPoliticaServicio.obtenerHijosMunicipioDepartamento(this.idMunicipioSeleccionado, true),
        this.productoRestriccionBarrioServicio.listadoPorProductoMunicipioDepartamento(this.producto.idProducto, this.idMunicipioSeleccionado, true)
      )
      .subscribe( async (
        [
          listaBarrios,
          listaBarriosRestringidos
        ]
      ) => {
        // llenado de las tablas
        this.listaBarrios = listaBarrios;
        this.listaTodosProductosRestriccionBarrioOriginal = listaBarriosRestringidos;
        this.listaTodosProductosRestriccionBarrio = [...this.listaTodosProductosRestriccionBarrioOriginal]
        await this.filtrarProductosRestriccionBarrio();
        this.carTabla = false;
      } );
    } else if (this.idDepartamentoSeleccionado && !this.idMunicipioSeleccionado) {
      this.listaBarrios = [];
      forkJoin
      (
        this.divisionPoliticaServicio.obtenerHijosMunicipioDepartamento(this.idDepartamentoSeleccionado, false),
        this.productoRestriccionBarrioServicio.listadoPorProductoMunicipioDepartamento(this.producto.idProducto, this.idDepartamentoSeleccionado, false)
      )
      .subscribe( async (
        [
          listaBarrios,
          listaBarriosRestringidos
        ]
      ) => {
        // llenado de las tablas
        this.listaBarrios = listaBarrios;
        this.listaTodosProductosRestriccionBarrioOriginal = listaBarriosRestringidos;
        this.listaTodosProductosRestriccionBarrio = [...this.listaTodosProductosRestriccionBarrioOriginal]
        await this.filtrarProductosRestriccionBarrio();
        this.carTabla = false;
      } );
    }
  }

  filtrarProductosRestriccionBarrio() {
    this.listaProductosRestriccionBarrioRestringidos = [];
    this.listaProductoRestriccionBarrio = [];
    // llenado productos restricciones barrios
    for (let restric of this.listaTodosProductosRestriccionBarrio) {
      if ( restric.indicadorHabilitado === true) {
        this.listaProductosRestriccionBarrioRestringidos.push(restric);
      }
    }
    this.listaFiltrada = this.listaProductosRestriccionBarrioRestringidos;
    for (let barrio of this.listaBarrios) {
      let restriccion = this.listaTodosProductosRestriccionBarrio.find(
        x => x.idDivisionPolitica === barrio.idDivisionPolitica);
      if ( restriccion === undefined) {
        // se crea el nuevo ProductoRestriccionBarrio parcial
        const nuevaRestricParcial = {} as ProductoRestriccionBarrio;
        nuevaRestricParcial.idProductoBarrio = null;
        nuevaRestricParcial.indicadorHabilitado = false;
        nuevaRestricParcial.idDivisionPolitica = barrio.idDivisionPolitica;
        nuevaRestricParcial.idProducto = this.producto.idProducto;
        nuevaRestricParcial.nombreBarrio = barrio.descripcionDivisonPolitica;
        nuevaRestricParcial.camino = barrio.camino;
        this.listaProductoRestriccionBarrio.push(nuevaRestricParcial);
      } else {
        if ( restriccion.indicadorHabilitado === false ) {
          this.listaProductoRestriccionBarrio.push(restriccion);
        }
      }
    }
  }
  // funcion para restringir un producto por un solo barrio
  restringir(restricciones: ProductoRestriccionBarrio[] = [], accion: boolean) {
    this.ejecutandoRestriccion = true;
    this.table.first = 0;
    this.table2.first = 0;

    if (restricciones && restricciones.length == 0) {
      this.navServicio.setMesage(0, {
        severity: 'info',
        summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('PRODUCTO.MSG_BARRIONOSELECCIONADO')
      });
      this.ejecutandoRestriccion = false;
      return;
    }

    restricciones.forEach(restriccion => {
      const restricIndex = this.listaTodosProductosRestriccionBarrio.findIndex(
        x => x.idProducto === restriccion.idProducto && x.idDivisionPolitica === restriccion.idDivisionPolitica
      );
      const restric = restricIndex !== -1 ? this.listaTodosProductosRestriccionBarrio[restricIndex] : null;

      restriccion.indicadorHabilitado = accion;

      if (accion) {
        if (!restric) {
          this.listaTodosProductosRestriccionBarrio.push(restriccion);
        } else {
          this.listaTodosProductosRestriccionBarrio[restricIndex] = restriccion;
        }
      } else {
        if (restric && !restric.idProductoBarrio) {
          this.listaTodosProductosRestriccionBarrio[restricIndex] = restriccion;
        } else if (restric) {
          this.listaTodosProductosRestriccionBarrio.splice(restricIndex, 1);
        }
      }

      // Revisar si restriccion está en listaTodosProductosRestriccionBarrioOriginal y actualizar idProductoBarrio
      const restriccionOriginal = this.listaTodosProductosRestriccionBarrioOriginal.find(
        x => x.idProducto === restriccion.idProducto && x.idDivisionPolitica === restriccion.idDivisionPolitica
      );

      if (restriccionOriginal) {
        restriccion = restriccionOriginal;
        restriccion.indicadorHabilitado = accion;
      }

      const modIndex = this.ListaBarriosMod.findIndex(
        item => item.idProducto === restriccion.idProducto && item.idDivisionPolitica === restriccion.idDivisionPolitica
      );

      if (modIndex !== -1) {
        this.ListaBarriosMod[modIndex] = restriccion;
      } else {
        this.ListaBarriosMod.push(restriccion);
      }
    });


    this.filtrarProductosRestriccionBarrio();

    setTimeout( () => {
      this.ejecutandoRestriccion = false;
    }, 500 );
  }



  // funcion para restringir un producto por todos los barrios
  restringirTodos(accion: boolean) {
    if ( accion ) {
      for (let restric of this.listaProductoRestriccionBarrio ) {
        let restriccionReal = this.listaTodosProductosRestriccionBarrio.find(
          x => x.idDivisionPolitica === restric.idDivisionPolitica && x.idProducto === restric.idProducto);
        if ( restriccionReal === undefined) {
          restric.indicadorHabilitado = true;
          this.listaTodosProductosRestriccionBarrio.push(restric);
          this.ListaBarriosMod.push(restric);
        } else {
          let index = this.listaTodosProductosRestriccionBarrio.indexOf(restric);
          restric.indicadorHabilitado = true;
          this.listaTodosProductosRestriccionBarrio[index] = restric;
          this.ListaBarriosMod.push(restric);

        }
      }
      this.filtrarProductosRestriccionBarrio();
      this.productoRestriccionBarrio = undefined;
    } else {
      // Se inhabilitan todos los productosRestricciones
      for (let restric of this.listaTodosProductosRestriccionBarrio) {
        // Se inhabilita el productoRestriccion existente
        if (restric.indicadorHabilitado === true){
          restric.indicadorHabilitado = false;
          this.ListaBarriosMod.push(restric);
        }
      }

      // Se eliminan los productosRestriccionOficina parciales
      this.listaTodosProductosRestriccionBarrio = this.listaTodosProductosRestriccionBarrio.filter(
        x => (x.indicadorHabilitado === true) || (x.indicadorHabilitado === false && x.idProductoBarrio !== null));
     // Se hace el filtro de restricciones por barrio
      this.filtrarProductosRestriccionBarrio();
      this.productoRestriccionBarrioRestringido = undefined;
    }
  }

  limpiarFiltro() {
    this.idDepartamentoSeleccionado = null;
    this.idMunicipioSeleccionado = null;
    this.lisMunicipios = [];
    this.listaProductoRestriccionBarrio = [];
    this.listaFiltrada = [];
    this.filtroActivo = true;
    this.productoRestriccionBarrio = []
    this.productoRestriccionBarrioRestringido = []
    this.ListaBarriosMod = []
    this.table.first = 0;
    this.table2.first = 0;
  }
}
